var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"route",on:{"click":_vm.to_version_anterior}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-trigger"},[_c('div',{staticClass:"ruta-principal"},[_c('div',[_c('span',{staticClass:"route-text"},[_vm._v(" Cambiar Version ")])]),_c('img',{attrs:{"src":require("@/assets/check.png"),"alt":""}})])])
}]

export { render, staticRenderFns }